import { type ContentTextComponent, type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { makeModuleTypeSelector } from "@client/selectors";
import { type AppState, type WithId } from "@client/types";
import React from "react";
import Component, { type MapProps } from "./component";
import { type ContainerProps } from "./Containers/container";

export type ContentContainerProps = WithId &
  ContainerProps & {
    TextComponent: ContentTextComponent;
    StaticContainer: React.ComponentType<RootContainerProps>;
    viewonly?: boolean;
  };
const makeMapStateToProps = () => {
  const moduleTypeSelector = makeModuleTypeSelector();

  return (state: AppState, props: ContentContainerProps): MapProps => {
    return {
      ...props,
      moduleType: moduleTypeSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
